/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListEmployeeAIDetections } from "../funcs/accessListEmployeeAIDetections.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAIDetectionsResult } from "../models/components/listaidetectionsresult.js";
import {
  ListEmployeeAIDetectionsRequest,
  ListEmployeeAIDetectionsSecurity,
} from "../models/operations/listemployeeaidetections.js";
import { unwrapAsync } from "../types/fp.js";
export type EmployeeAIDetectionsQueryData = ListAIDetectionsResult;

export function prefetchEmployeeAIDetections(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListEmployeeAIDetectionsRequest,
  security?: ListEmployeeAIDetectionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildEmployeeAIDetectionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildEmployeeAIDetectionsQuery(
  client$: GramCore,
  request: ListEmployeeAIDetectionsRequest,
  security?: ListEmployeeAIDetectionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<EmployeeAIDetectionsQueryData>;
} {
  return {
    queryKey: queryKeyEmployeeAIDetections({
      userEmail: request.userEmail,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function employeeAIDetectionsQueryFn(
      ctx,
    ): Promise<EmployeeAIDetectionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListEmployeeAIDetections(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyEmployeeAIDetections(
  parameters: {
    userEmail: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listEmployeeAIDetections", parameters];
}
